import {
    POST_CREATION_TARGET,
    PostCreationResponse,
    PostType,
} from "../Post.types";
import { GroupTypeEnum } from "../../../Pages/GroupDetailsPage/Group.types";
import { LocationType } from "../../SearchHeader/ListItem/ListItemLocation.types";
import { PostUpdateResponse } from "@infrastructure/Services/GroupService.types";

export type PostFormModalType = {
    data: PostType | undefined;
    postFormSubmissionCallback: (
        post: PostType,
        response: PostCreationResponse | PostUpdateResponse,
    ) => void;
    groupType?: GroupTypeEnum;
    handleClosingPostForm?: () => void;
    initialUserLocation?: LocationType;
    postCreationTarget?: POST_CREATION_TARGET;
    postFormModalCloseCallback?: () => void;
    setInitialUserLocation?: (location: LocationType | undefined) => void;
};

export enum POST_FORM_CONTENT_INPUT {
    DEFAULT,
    IMAGE_INPUT,
    LOCATION_INPUT,
    LINKOUT_URL_INPUT,
    POLL_INPUT,
}

export enum POST_FORM_TABS {
    DEFAULT,
    LINKOUT,
    LOCATION,
    POLL,
}

export type UploadImagesInput = {
    images: UploadedImage[];
    open: boolean;
    setFormActive: (value: boolean) => void;
    setImages: (images: UploadedImage[] | []) => void;
    setIsUploading: (value: boolean) => void;
    abortController?: AbortController;
    mediaType?: MEDIA_TYPE;
};

export enum MEDIA_TYPE {
    "VIDEO",
    "IMAGES",
}

export enum POST_SOURCE_TYPE {
    CREATE_POST_FAB = "ts_group_fab",
    TEASER_INPUT = "ts_group_input",
    MAP_POST_CARD = "co_map_postCard",
    MAP_POI_CARD = "co_map_poiCard",
    TRUCKTOUR_STOP_INPUT = "tt_stop_input",
}

export type PostImagesPreview = {
    triggerInput?: () => void;
    handleOnRemoveImage: (index: number) => void;
    images: UploadedImage[];
    isHidden: boolean;
    handleDragImage: (newDraggedImages: DraggableImage[]) => void;
    handleImageUploadRetry: (image: UploadedImage) => void;
    failedUploadsDetected: boolean;
    inappropriateContentDetected: boolean;
    scrollable?: boolean;
};
export type ImageItemType = {
    handleImageUploadRetry: (image: UploadedImage) => void;
    handleOnRemoveImage: (index: number) => void | undefined;
    image: UploadedImage;
    itemKey: number;
};
export type UploadedImage = {
    id?: number;
    imageUrl: string;
    imageFile: File | undefined;
    delete: boolean;
    isUploading: boolean;
    videoThumbnailUrl?: string;
    mediaType?: "video" | "image";
    key?: string;
    bucket?: string;
    isInappropriate: boolean;
    failed: boolean;
    uploaded: boolean;
};
export type DraggableImage = {
    id: number;
    image: UploadedImage;
};
